import React from "react";
import bgImg from "../Images/hero.jpeg";
import Header from "./Header";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Container, Row, Col, Card } from "react-bootstrap";

const Ourproduct = () => {
  const cards = [
    {
      id: 1,
      title: "uPVC Casing Pipe",
      desc: (
        <>
          डालसन बोरवेल केसिंग पाइप्स घरेलू, औद्योगिक और कृषि सभी तरह की जरूरतों के लिए सर्वश्रेष्ठ विकल्प है।<br />
          लाभ:<br />
          ❖ रख रखाव का खर्चा कम<br />
          ❖ जंग और रासायनिक प्रतिक्रिया से बचा रहे<br />
          ❖ जल का भरपूर प्रवाह<br />
          तकनीकी विवरण:<br />
          विशिष्ट गुरुत्व: 1.4 से 1.46 ग्राम/सी.सी.<br />
          विकट तनुकरण तापमान: &gt;80°C<br />
          तनन क्षमता: &gt;50 एमपीए<br />
          प्रभाव क्षमता: &gt;10% TIR<br />
          पाइप का रंग: नीला<br />
          रेंज:<br />
          ❖ IS-12818:2010 के अनुसार<br />
          ❖ 80 मी. तक की गहराई के लिए CM पाइप्स (ND-100-250 मिमी)<br />
          ❖ 250 मी. तक की गहराई के लिए CM पाइप्स (ND-100-250 मिमी)<br />
          ❖ RS पाइप्स (ND-100-250 मिमी)<br />
          SDR रेंज:<br />
          ❖ 80 फिट की गहराई के लिए SDR 47 (OD-90-225 मिमी)<br />
          ❖ 150 फिट की गहराई के लिए SDR 36 (OD-110-180 मिमी)<br />
          ❖ 250 फिट की गहराई के लिए SDR 31 (OD-90-225 मिमी)<br />
          ❖ 225 मिमी. तक के OD भी उपलब्ध
        </>
      ),
      img: "https://www.supreme.co.in/uploads/images/DcsMZ6RoL1IV0Ks0AmbbpDJTsaw20bNwqaWhjUC9.jpg",
    },
    {
      id: 2,
      title: "PVC Pipe",
      desc: (
        <>
        आर.पी.वी.सी. पाइप 
जिसमे है उच्चतम भार और फोर्स वहन करने की क्षमता |
विशेषताएं 
❖	सालवेंट सीमेंट जॉइन्ट की सुविधा वाला 
❖	लगाने व रख-रखाव में आसान 
❖	अधिक विद्युतरोधी व रसायन रोधी 
❖	लचीला , कम वजनी ,मजबूत ,लाने ले जाने में आसान 
❖	टर्माइट मुक्त यू.वी. प्रतिरोधी 
❖	आईएस 4985:2000 मापदण्डो के अनुसार निर्मित 
❖	नमी और घिसाई की चिंता नहीं 
कृषि/औद्योगिक /घरेलू एवं अन्य उपयोग 
❖	सिंचाई के लिए उपयुक्त 
❖	रासायनिक कचरे का निष्कासन 
❖	ऐसिड और स्लरी का परिवहन 
❖	क्षारीय जल का प्रबंधन 
❖	शहरों में पीने के पानी के सप्लाई के लिए 
❖	टेलिकम्युनिकेशन केबल डकटिंग
          लाभ:<br />
          ❖ बिना रख-रखाव एवं खर्च के लंबे समय तक चले<br />
          ❖ समय, मेहनत और पैसा बचाए, स्वास्थ्य के अनुकूल<br />
          ❖ ऊर्जा की बचत, रिसाव मुक्त<br />
          फिटिंग्स (IS 7834:1987 के अनुसार): टीज, एलबोज, कपलर्स, MTA, FTA, सर्विस सैडल्स, रिड्यूसर एंड कैप्स, टेलपीसेज, रिड्यूसिंग टी, वाय टी आदि।<br />
          तकनीकी विवरण:<br />
          मानक: 4985:2000<br />
          दाब क्षमता: 2.5 से 12.5 कि.ग्रा./से.मी.<br />
          मटीरियल: पीवीसी<br />
          तनन क्षमता: &gt;50 एमपीए<br />
          विकट तनुकरण तापमान: &gt;80°C<br />
          सेवा तापमान: 0 से 60°C<br />
          रंग: हल्का ग्रे<br />
          रेंज: 20 मिमी. से 400 मिमी, 2.5 कि.ग्रा. से 10 कि.ग्रा.
        </>
      ),
      img: "https://5.imimg.com/data5/SELLER/Default/2024/2/390641582/TA/KU/RA/9380720/texmo-75mm-pvc-pipe-1000x1000.png",
    },
    {
      id: 3,
      title: "HDPE Pipes",
      desc: (
        <>
          • HDPE Pipe 2 inch <br />
          • HDPE pipe 2.5 inch<br />
          • HDPE pipe 3 inch<br />
          • HDPE pipe 4 inch<br />
          • HDPE pipe 5 inch<br />
        </>
      ),
      img: "https://5.imimg.com/data5/MP/YB/WS/SELLER-81360351/jain-pvc-pipe-1000x1000.jpg",
    },
    {
      id: 4,
      title: "Column Pipe",
      desc: (
        <>
        ❖	कृषि सिंचाई ,घरेलू ,औद्योगिक खनन और केमिकल वितरण के लिए 
❖	सबमरसिबल और जेट पम्प के जरिए पानी चढ़ाने में 
बिना किसी प्रतिकूल प्रभाव के क्षारीय ,बालू युक्त ,रसायन युक्त या नुकसानदायक 
पानी के लिए भी वर्षों तक उपयोगी |
          लाभ: आपके निवेश को कभी डूबने ना दे, लंबी सर्विस लाइफ, किसी भी तरह की सर्विस में कार्य करने में सक्षम।<br />
          तकनीकी विवरण: मानक: KRITI own std., मटीरियल: रिजिड पीवीसी, विशिष्ट गुरुत्व: 1.4-1.46 ग्राम/सी.सी., तनन क्षमता: &gt;50 एमपीए, प्रभाव क्षमता: {"<TIR 10%"}, विकट तनुकरण तापमान: 80°C।<br />
          रेंज: 80 मी तक की गहराई का Optima Plus Bore, 105 मी तक Medium Plus Bore, 200 मी तक Standard & Standard Plus Bore, 285 मी तक Heavy Bore।
        </>
      ),
      img: "https://vishalpipes.com/images/polymers-pipes/pvc-pipes/zoom-column-pipes.jpg",
    },
    {
      id: 5,
      title: "uPVC Pressure Pipe",
      desc: (
        <>
          • Diameter: 1 inch to 12 inches<br />
          • Length: Usually 6–12 meters per pipe section<br />
          • Wall Thickness: 3–15 mm depending on pressure rating<br />
          • Pressure Rating: 6–10 bar<br />
          • Corrosion-resistant and suitable for irrigation & water supply
        </>
      ),
      img: "https://cpimg.tistatic.com/04225620/b/4/UPVC-Pressure-Pipes.jpg",
    },
    {
      id: 6,
      title: "Submersible Pumpset",
      desc: (
        <>
          • Available in 1 HP to 200 HP<br />
          • Suitable for domestic and agricultural water supply<br />
          • Stainless steel body for corrosion resistance<br />
          • High efficiency with low noise operation<br />
          • Compatible with uPVC and column pipes
        </>
      ),
      img: "https://tse3.mm.bing.net/th/id/OIP.aseKbo4S4_EgPVqN47FVAwHaG_?w=600&h=566&rs=1&pid=ImgDetMain&o=7&rm=3",
    },
  ];

  return (
    <>
      <Header />
      <Navbar />
      <section
        className="container-fluid d-flex align-items-center justify-content-center text-center"
        style={{
          minHeight: "45vh",
          backgroundImage: `linear-gradient(
            rgba(255, 201, 74, 0.88),
            rgba(255, 201, 74, 0.88)
          ), url(${bgImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <h1 className="fw-bold display-5 mb-3 text-dark">Our-Product</h1>
          <p className="mx-auto text-dark" style={{ maxWidth: "720px", fontSize: "18px" }}>
            We value the opportunity to connect with our customers and answer any questions they may have.
          </p>
        </div>
      </section>

      <section className="my-5">
        <Container>
          <Row className="justify-content-center">
            {cards.map((card) => (
              <Col key={card.id} lg={4} md={6} sm={12} className="mb-4 d-flex">
                <Card className="flex-fill">
                  <Card.Img variant="top" src={card.img} />
                  <Card.Body>
                    <Card.Title>{card.title}</Card.Title>
                    <Card.Text>{card.desc}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
};

export default Ourproduct;
